import firstBirthdayFinalLocalReadyData from "../data/firstBirthdayFinalLocalReadyData.json";

export const FIRST_BIRTHDAY_TEST_MODE_PARAM = "fbTestMode";
export const FIRST_BIRTHDAY_TEST_MODE_VALUE = "1";
export const FIRST_BIRTHDAY_LOCALHOST_WORKBOOK_PATH =
  "test-output/decorzoom_products_first_birthday_final_local_ready_2026-04-14.xlsx";
export const FIRST_BIRTHDAY_LOCALHOST_DATASET_PATH =
  "src/data/firstBirthdayFinalLocalReadyData.json";

export const isLocalhostHost = (hostname) =>
  hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";

export const isFirstBirthdayTestModeEnabled = (search = "", hostname = "") => {
  if (!isLocalhostHost(hostname)) return false;

  const params = new URLSearchParams(search);
  return params.get(FIRST_BIRTHDAY_TEST_MODE_PARAM) === FIRST_BIRTHDAY_TEST_MODE_VALUE;
};

export const getFirstBirthdayTestModeProducts = () => firstBirthdayFinalLocalReadyData;

export const findFirstBirthdayTestProductById = (productId) =>
  firstBirthdayFinalLocalReadyData.find((product) => product.id === productId) || null;

export const buildPathWithFirstBirthdayTestMode = (pathname, isEnabled) => {
  if (!isEnabled) return pathname;

  const separator = pathname.includes("?") ? "&" : "?";
  return `${pathname}${separator}${FIRST_BIRTHDAY_TEST_MODE_PARAM}=${FIRST_BIRTHDAY_TEST_MODE_VALUE}`;
};
